import { Box, Container, Paper, Typography } from "@mui/material";

const AboutUs = () => {
  return (
    <Container sx={{ padding: "10px" }}>
      <Box component={Paper} sx={{ padding: "10px", borderRadius: "10px" }}>
        <Typography variant="h3" fontSize={"1.5rem"}>
          About Us
        </Typography>

        <Typography variant="body1">
          At CosmetixHub, we believe beauty is an experience—elegant,
          effortless, and tailored to you. We curate and compare premium
          cosmetics from the world’s most coveted brands, so you don’t have to
          settle for less. With detailed insights, authentic reviews, and direct
          affiliate links, we elevate your beauty journey into something truly
          refined. Discover, compare, and indulge—because luxury starts with the
          right choice.
        </Typography>
      </Box>
      <Box
        component={Paper}
        sx={{ padding: "10px", marginTop: "10px", borderRadius: "10px" }}
      >
        <Typography variant="h3" fontSize={"1.5rem"}>
          Our Vision
        </Typography>

        <Typography variant="body1">
          To become the most trusted and refined destination for beauty product
          discovery, where elegance meets intelligence. We envision a world
          where every individual can confidently choose cosmetics that enhance
          their unique essence—guided by transparency, innovation, and a touch
          of luxury. At CosmetixHub, we aspire to redefine the online beauty
          experience—making it effortlessly exquisite.
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutUs;
